export type ServiceType = 'dine-in' | 'take-away';

export interface Palette {
  // page background gradients
  pageFrom: string;
  pageVia: string;
  pageTo: string;

  // primary button / gradients
  primaryFrom: string;
  primaryTo: string;
  primaryFromHover: string;
  primaryToHover: string;

  // light backgrounds for cards / accents
  bgLight: string;
  bgDark: string;

  // text accent (e.g. headings, small badges)
  textAccent: string;

  // badge gradient
  badgeFrom: string;
  badgeTo: string;

  // borders
  borderAccent: string;
}

const dineIn: Palette = {
  pageFrom: 'from-slate-50',
  pageVia: 'via-sky-50',
  pageTo: 'to-sky-50',

  primaryFrom: 'from-sky-500',
  primaryTo: 'to-sky-500',
  primaryFromHover: 'from-sky-600',
  primaryToHover: 'to-sky-600',

  bgLight: 'bg-sky-50/80',
  bgDark: 'dark:bg-sky-900/30',

  textAccent: 'text-sky-500',

  badgeFrom: 'from-sky-500',
  badgeTo: 'to-sky-500',

  borderAccent: 'border-sky-200/50',
};

const takeAway: Palette = {
  pageFrom: 'from-slate-50',
  pageVia: 'via-orange-50',
  pageTo: 'to-orange-50',

  primaryFrom: 'from-orange-500',
  primaryTo: 'to-red-500',
  primaryFromHover: 'from-orange-600',
  primaryToHover: 'to-red-600',

  bgLight: 'bg-orange-50/80',
  bgDark: 'dark:bg-orange-900/30',

  textAccent: 'text-orange-500',

  badgeFrom: 'from-orange-500',
  badgeTo: 'to-red-500',

  borderAccent: 'border-orange-200/50',
};

export function getServicePalette(type: ServiceType = 'dine-in'): Palette {
  return type === 'take-away' ? takeAway : dineIn;
}

export default getServicePalette;
